function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $967ea62d8eb80db6$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"Y15zO":"index.f7fa0225.js","jmW5S":"About.5a0823b2.js","c2IcO":"Contact.3271ecd4.js"}'));


//# sourceMappingURL=index.d65bd97a.js.map
